<div class="child-cells">
	<div class="add-cell editable" data-type="QuizCollectionItem">{{t "editor.addQuiz"}}</div>
	<div class="add-cell editable" data-type="AppCollectionItem">{{t "editor.addApp"}}</div>
	<div class="add-cell editable" data-type="LinkCollectionItem">{{t "editor.addLink"}}</div>
</div>
